import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getAcceptanceFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t(`acceptances.fields.Title`),
      columnHeader: t(`acceptances.columns.title`),
      allowAsConditionSource: true,
    },
    DateAcceptedFrom: {
      fieldId: 'DateAcceptedFrom',
      formLabel: t(`acceptances.fields.DateAcceptedFrom`),
      columnHeader: t(`acceptances.columns.accepted_from`),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
    },
    DateAcceptedTo: {
      fieldId: 'DateAcceptedTo',
      formLabel: t(`acceptances.fields.DateAcceptedTo`),
      columnHeader: t(`acceptances.columns.accepted_to`),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
    },
    requestedBy: {
      fieldId: 'requestedBy',
      formLabel: t(`acceptances.fields.requestedBy`),
      columnHeader: t(`columns.requested_by`),
    },
    approvedBy: {
      fieldId: 'approvedBy',
      formLabel: t(`acceptances.fields.approvedBy`),
      columnHeader: t(`columns.approved_by`),
    },
    Status: {
      fieldId: 'Status',
      formLabel: t(`acceptances.fields.Status`),
      columnHeader: t(`acceptances.columns.status`),
      allowAsConditionSource: true,
      displayType: { displayType: 'rating', ratingKey: 'acceptance_status' },
    },
    Details: {
      fieldId: 'Details',
      formLabel: t(`acceptances.fields.Details`),
      columnHeader: t(`acceptances.columns.details`),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    files: {
      fieldId: 'files',
      formLabel: t(`fields.newFiles`),
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
